import { Constants } from '@repo/shared';

export const storeToken = (token: string) => {
  localStorage.setItem(Constants.ACCESS_TOKEN, token);
};

export const clearToken = () => {
  localStorage.removeItem(Constants.ACCESS_TOKEN);
};

export const getToken = () => localStorage.getItem(Constants.ACCESS_TOKEN);

export const decodeUsernameFromToken = (token: string): string => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return '';
    const json = atob(payload.replace(/-/gu, '+').replace(/_/gu, '/'));
    return JSON.parse(json).email ?? '';
  } catch {
    return '';
  }
};
